<template>
  <v-dialog
    v-model="$produtos_gerenciar.descriptionModal"
    class="base pa-8 rounded-xl"
    persistent
    max-width="900"
    min-height="300"
    max-height="300"
  >
    <v-card class="base pa-4">
      <v-card-title class="px-0 pt-0"
        >Adicionar Descrição do Produto</v-card-title
      >
      <div class="close-button">
        <CloseIcon @action="closeModal" />
      </div>
      <v-card-text class="px-0 pt-10">
        <v-row>
          <v-col cols="12">
            <label class="input-labels" required
              >Descrição do Produto - Português</label
            >
            <editor
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br
              "
              id="descriptionProduct1"
              placeholder="Insira a descrição do produto"
            />
          </v-col>
          <v-col cols="5">
            <div class="termo-modal-container6 secondary">
              <v-checkbox v-model="$produtos_gerenciar.descriptionTranslate">
                <template v-slot:label>
                  <div>Adicionar traduções</div>
                </template>
              </v-checkbox>
            </div>
          </v-col>
          <v-scroll-y-transition>
            <section
              style="width: 100%"
              v-show="$produtos_gerenciar.descriptionTranslate"
            >
              <v-col cols="12">
                <label class="input-labels"
                  >Descrição do Produto - Inglês</label
                >
                <editor
                  id="descriptionProduct2"
                  v-model="
                    $produtos_gerenciar.cadastro.dados_cadastrais
                      .descritivo_en_us
                  "
                  placeholder="Insira a descrição do produto em inglês"
                />
              </v-col>
              <v-col cols="12">
                <label class="input-labels"
                  >Descrição do Produto - Espanhol</label
                >
                <editor
                  id="descriptionProduct3"
                  v-model="
                    $produtos_gerenciar.cadastro.dados_cadastrais
                      .descritivo_es_es
                  "
                  placeholder="Insira a descrição do produto em espanhol"
                ></editor>
              </v-col>
            </section>
          </v-scroll-y-transition>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-0">
        <RegistrationActions :actions="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import RegistrationActions from "@/components/global/RegistrationActions.vue";
import editor from "@/components/global/editor.vue";

export default {
  name: "DescriptionProduct",
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.saveDescription(),
          disabled: false,
        },
        {
          name: "Cancelar",
          action: () => this.closeModal(),
          disabled: false,
        },
      ],
      originalDescription: null,
    };
  },
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
    RegistrationActions,
    editor,
  },
  methods: {
    hasTranslation() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es
      ) {
        this.$produtos_gerenciar.descriptionTranslate = true;
      }
    },
    closeModal() {
      this.$produtos_gerenciar.descriptionModal = false;
      this.restoreOriginalDescription();
    },
    cleanDescription() {
      this.restoreOriginalDescription();
      this.$produtos_gerenciar.descriptionTranslate = false;
    },
    saveDescription() {
      this.updateOriginalDescription();
      this.updatePayload();
      this.closeModal();
    },
    restoreOriginalDescription() {
      if (this.originalDescription) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br =
          this.originalDescription.pt_br;
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us =
          this.originalDescription.en_us;
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es =
          this.originalDescription.es_es;
      }
    },
    updateOriginalDescription() {
      this.originalDescription = {
        pt_br:
          this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br,
        en_us:
          this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us,
        es_es:
          this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es,
      };
    },
    updatePayload() {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo = `<pt_BR>${this.originalDescription.pt_br}</pt_BR><en_US>${this.originalDescription.en_us}</en_US><es_ES>${this.originalDescription.es_es}</es_ES>`;
    },
  },
  watch: {
    "$produtos_gerenciar.descriptionModal"(value) {
      if (
        this.$produtos_gerenciar.produtosAddEdit === "new" &&
        value === true
      ) {
        this.updateOriginalDescription();
      } else if (
        this.$produtos_gerenciar.produtosAddEdit === "edit" &&
        value === true
      ) {
        this.restoreOriginalDescription();
      } else {
        this.cleanDescription();
      }

      this.hasTranslation();
    },
    "$produtos_gerenciar.descriptionTranslate"(value) {
      if (!value) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us =
          "";
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es =
          "";
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br"(e) {
      if (e !== "" && e !== "<p><br></p>") {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo_pt_br = false;
      } else {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo_pt_br = true;
      }
    },
  },
  mounted() {
    this.hasTranslation();
    this.updateOriginalDescription();
  },
  destroyed() {
    this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo = [];
    this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br = "";
    this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_en_us = "";
    this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_es_es = "";
  },
};
</script>
<style scoped>
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 3%;
  display: flex;
  justify-content: flex-end;
}
.description-editor-input {
  height: auto;
  width: 100%;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
  background: #fff;
  overflow: auto;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.termo-modal-container6 {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0.125rem 1.5625rem;
  background-color: #c9c9c9;
  border-radius: 0.9375rem;
}
</style>
